/**
 * Contacts map: preview image → create Yandex iframe on first interaction.
 *
 * @return {void}
 */
export function initContactsMap() {
	const maps = document.querySelectorAll('[data-contact-map]');

	maps.forEach((map) => {
		const trigger = map.querySelector('[data-contact-map-trigger]');
		const frame = map.querySelector('[data-contact-map-frame]');
		const mapUrl = map.getAttribute('data-map-url');

		if (!trigger || !frame || !mapUrl || map.classList.contains('is-loaded')) {
			return;
		}

		/**
		 * @return {void}
		 */
		const loadMap = () => {
			if (map.classList.contains('is-loaded')) {
				return;
			}

			const iframe = document.createElement('iframe');
			iframe.src = mapUrl;
			iframe.title = trigger.getAttribute('aria-label') || 'Map';
			iframe.loading = 'lazy';
			iframe.referrerPolicy = 'no-referrer-when-downgrade';
			iframe.allowFullscreen = true;

			frame.hidden = false;
			frame.appendChild(iframe);

			trigger.hidden = true;
			map.classList.add('is-loaded');
		};

		trigger.addEventListener('click', loadMap);

		trigger.addEventListener('keydown', (event) => {
			if ('Enter' !== event.key && ' ' !== event.key) {
				return;
			}

			event.preventDefault();
			loadMap();
		});
	});
}
